// TODO consolidate the constants
let alerts = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
}

const alertLevels = {
  computed: {
    isInfo () {
      return this.notification.alert_level === alerts.INFO
    },
    isSuccess () {
      return this.notification.alert_level === alerts.SUCCESS
    },
    isWarning () {
      return this.notification.alert_level === alerts.WARNING
    },
    isError () {
      return this.notification.alert_level === alerts.ERROR
    }
  }
}

export {
  alertLevels
}



// WEBPACK FOOTER //
// ./src/app/components/common/notifications/mixins.js